import PropTypes from 'prop-types'

export default PropTypes.arrayOf(PropTypes.shape({
  key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  permissions: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string.isRequired),
    PropTypes.string,
  ]),
  permissionsWithRegex: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string.isRequired),
    PropTypes.string,
    PropTypes.object,
  ]),
  children: PropTypes.string,
  trailingAddon: PropTypes.oneOfType([PropTypes.node, PropTypes.elementType]),
  onClick: PropTypes.func,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
    hash: PropTypes.string,
  })]),
  primary: PropTypes.bool,
  neutral: PropTypes.bool,
}))
